


export class UsuarioStatus {
  "Codigo";
  "Nome";
  "Descricao";
  "Usuario";
  "DataAlteracao";
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `UsuarioStatus`.
   */
  static getModelName() {
    return "UsuarioStatus";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of UsuarioStatus for dynamic purposes.
  **/
  static factory(data) {
    return new UsuarioStatus(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'UsuarioStatus',
      plural: 'UsuarioStatuses',
      path: 'UsuarioStatuses',
      properties: {
        "Codigo": {
          name: 'Codigo',
          type: 'number'
        },
        "Nome": {
          name: 'Nome',
          type: 'string'
        },
        "Descricao": {
          name: 'Descricao',
          type: 'string'
        },
        "Usuario": {
          name: 'Usuario',
          type: 'string'
        },
        "DataAlteracao": {
          name: 'DataAlteracao',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/UsuarioStatus.js